import cn from "classnames"
import richText from "utilities/richText"
import DynamicVideo from "components/DynamicVideo"

export default function VideoAndContent({ blok }) {
  return (
    <section className={cn("py-12 px-8", blok.background_color && `bg-${blok.background_color}`)}>
      <div className="max-w-screen-xl mx-auto flex flex-col xl:flex-row gap-8">
        <div className="prose-h2:text-green-pine prose-h2:pb-2 prose-a:text-green-pine prose-p:pb-2 basis-1/2">
          {richText(blok.content)}
        </div>
        <div className="basis-1/2">
          <DynamicVideo {...blok.video[0]} />
        </div>
      </div>
    </section>
  )
}
